<template>
  <div id="page-order-code">
    <div class="banner ban_title">
      <h1>由<img src="https://f.msup.com.cn/icon/msup_logo_white.png" />提供票务支持</h1>
    </div>
    <div class="pc_content">
      <div class="main con">
        <div class="alltic pc">
          <table>
            <tr class="caption">
              <td class="t1">门票名称</td>
              <td class="t2">优惠单价/原价</td>
              <td class="t3">说明</td>
              <td class="t4">数量</td>
            </tr>
            <tr>
              <td class="t1">{{ ticket.goodsName || ticket.title || '门票' }}</td>
              <td class="t2">
                ￥{{ ticket.amount || '0' }}&nbsp;/&nbsp;
                <span>￥{{ ticket.price || '0' }}</span>
                （元 / 张）
              </td>
              <td class="t3">{{ ticket.description || '参会门票' }}</td>
              <td class="t4">
                <button class="a1" @click="reduceNum" :disabled="total === parseInt(ticket.minBuyNum || 1) || total === 0">-</button>
                <span class="tsspan">{{ total }}</span>
                <button class="a2" @click="addNum">+</button>
              </td>
            </tr>
          </table>
        </div>
        <div class="alltic mob">
          <div class="single">
            <div class="top">
              <div class="le">
                <div>
                  <img src="../assets/img/order02.png" />
                </div>
                <p>{{ ticket.goodsName || ticket.title || '门票' }}</p>
              </div>
              <div class="ri">
                <button @click="reduceNum" :disabled="total === 0">-</button>
                <p>{{ total }}</p>
                <button @click="addNum">+</button>
              </div>
            </div>
            <div class="min">
              <div class="pri">
                <p>￥</p>
                <h1>{{ ticket.amount || '0' }}</h1>
                <span>（元 / 张）</span>
              </div>
              <h2>￥{{ ticket.price || '0' }}</h2>
              <h3>{{ ticket.description || '参会门票' }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="main con wrap-flex">
        <div class="form-container">
          <div class="form-group">
            <label><span class="required">*</span>优惠码：</label>
            <!-- <input type="text" v-model="hash" placeholder="请输入优惠码" disabled> -->
            <div class="verify-code-container">
              <input type="text" v-model="hash" placeholder="请输入优惠码">
              <button class="change-hash-btn" @click="changeHash" :disabled="hash === _hash">更换优惠码</button>
            </div>
          </div>

          <div class="form-group">
            <label><span class="required">*</span>姓名：</label>
            <input type="text" v-model="formData.name" placeholder="请输入姓名">
          </div>

          <div class="form-group">
            <label><span class="required">*</span>公司：</label>
            <input type="text" v-model="formData.company" placeholder="请输入公司名称">
          </div>

          <div class="form-group">
            <label><span class="required">*</span>邮箱：</label>
            <input type="email" v-model="formData.email" placeholder="请输入邮箱地址">
          </div>

          <div class="form-group">
            <label><span class="required">*</span>手机号：</label>
            <input type="tel" v-model="formData.phone" placeholder="请输入手机号">
          </div>

          <div class="form-group">
            <label><span class="required">*</span>验证码：</label>
            <div class="verify-code-container">
              <input type="text" v-model="formData.verifyCode" placeholder="请输入验证码">
              <button class="get-code-btn" @click="getVerifyCode" :disabled="countdown > 0">获取验证码</button>
            </div>
          </div>

          <div class="form-group">
            <label>发票信息：</label>
            <textarea type="text" v-model="formData.invoiceInfo" placeholder="请输入发票信息"></textarea>
            <!-- <input type="text" v-model="formData.invoiceInfo" placeholder="请输入发票信息"> -->
          </div>
        </div>
        <div class="method-container wrap-flex-end">
          <h1 class="wrap-flex-end"><span>总计：</span>{{ totalPrice }}</h1>
          <!-- <button class="submit-btn" @click="onSubmit">立即支付</button> -->
          <div class="morebtn">
            <a @click="onSubmit">立即支付</a>
          </div>
          <div class="morebtn">
            <a @click="backOrder">放弃优惠</a>
          </div>
          <p><span>*</span> 注：使用优惠码购票的用户，请在支付完成后联系工作人员领取大会门票。已领取的门票请于本网站登录后前往个人中心、或登录msup会议助手小程序进入个人中心查看。</p>
          <p v-if="ticket.linkman">当前优惠码专属客服：{{ ticket.linkman }}<slot v-if="ticket.linkmanPhone"
          ><br>联系电话：{{ ticket.linkmanPhone }}</slot><slot v-if="ticket.linkmanEmail"
          ><br>联系邮箱：{{ ticket.linkmanEmail }}</slot></p>
        </div>
      </div>
    </div>
    <a href="" id="pay-link-tag" style="display:none;"></a>
  </div>
</template>

<script>
import { mixinSession } from '../mixin'

export default {
  name: 'OrderCode',
  mixins: [mixinSession],
  data () {
    return {
      hash: '',
      total: 0,
      ticket: {
        title: '门票',
        price: '0',
        amount: '0',
        description: '参会门票'
      },
      formData: {
        name: '',
        company: '',
        email: '',
        phone: '',
        verifyCode: '',
        invoiceInfo: ''
      },
      countdown: 0
    }
  },
  computed: {
    _hash () {
      return this.$route.query.qd || this.$route.query.hash || ''
    },
    totalPrice () {
      let total = (this.total || 0) * (this.ticket.amount || this.ticket.price || 0)
      total = total > 0 ? total.toFixed(2) : 0
      return total
    }
  },
  watch: {
    _hash: {
      handler (val) {
        this.hash = val || ''
        if (val) {
          this.getDetail(val)
        } else {
          this.$message.closeAll()
          this.$message({message: '无效优惠码', type: 'warning'})
          this.backOrder()
        }
      },
      immediate: true
    }
  },
  created () {
    this.initInfo()
  },
  methods: {
    reduceNum () {
      this.total = Math.max(this.ticket.minBuyNum || 1, this.total - (this.ticket.minBuyNum || 1))
    },
    addNum () {
      this.total = (this.total || (this.ticket.minBuyNum || 1)) + (this.ticket.minBuyNum || 1)
    },
    getDetail (hash, isChange = false) {
      console.log('')
      console.log('hash', hash)
      console.log('')
      // `https://www.msup.com.cn/api/api-common/get-diys-data?hash=${hash}`
      // this.ticket
      this.$http.jsonp('https://www.msup.com.cn/api/api-common/get-diys-data', {
        params: {
          hash: hash
        }
      }).then((data) => {
        return data.json()
      }).then(response => {
        console.log('response', response)
        if ([200, '200'].includes(response.status)) {
          this.ticket = response.data || {}
          if (this.ticket.price) {
            this.ticket.price = parseFloat(this.ticket.price).toFixed(2)
          }
          if (this.ticket.amount) {
            this.ticket.amount = parseFloat(this.ticket.amount).toFixed(2)
          }
          if (this.ticket.amount || this.ticket.price) {
            this.total = this.ticket.minBuyNum || 1
          }
          console.log('ticket', this.ticket)
          if (isChange) {
            if (this.hash !== this._hash) {
              this.$router.replace(this.formatHref('/code', { qd: this.hash }))
            }
          }
        } else {
          this.$message.closeAll()
          this.$message({message: response.message || '获取门票详情失败，请检查优惠码是否正确', type: 'warning'})
          if (!isChange) {
            setTimeout(() => {
              this.backOrder()
            }, 1000)
          }
        }
      }).catch(error => {
        console.error('获取门票详情失败:', error)
        this.$message({message: '获取门票详情失败，请检查优惠码是否正确', type: 'warning'})
        if (!isChange) {
          setTimeout(() => {
            this.backOrder()
          }, 1000)
        }
      })
    },
    getVerifyCode () {
      if (!this.formData.phone) {
        this.$message({ message: '请输入手机号', type: 'warning' })
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.formData.phone)) {
        this.$message({ message: '请输入正确的手机号', type: 'warning' })
        return
      }

      // 添加按钮禁用状态
      const btn = document.querySelector('.get-code-btn')
      // if (btn) btn.disabled = true
      if (btn) btn.setAttribute('disabled', '')

      this.$http.jsonp('https://www.msup.com.cn/login/default/send-captcha', {
        params: {
          phone: this.formData.phone
        }
      }).then((data) => {
        return data.json()
      }).then(response => {
        if ([200, '200'].includes(response.code)) {
          this.$message({message: '验证码发送成功', type: 'success'})
          // 这里可以添加倒计时逻辑
          this.startCountdown()
        } else {
          this.$message({message: response.message || '验证码发送失败', type: 'warning'})
        }
      }).catch(error => {
        console.error('验证码请求失败:', error)
        this.$message({message: '验证码请求失败，请重试', type: 'warning'})
        // if (btn) btn.disabled = false
        if (btn) btn.removeAttribute('disabled')
      })
    },

    changeHash () {
      this.getDetail(this.hash, true)
    },

    startCountdown () {
      let seconds = 60 // 60秒倒计时
      this.countdown = seconds
      const btn = document.querySelector('.get-code-btn')
      if (!btn) return

      const originalText = btn.textContent
      const timer = setInterval(() => {
        btn.textContent = `${seconds}秒后重试`
        seconds--
        this.countdown = seconds

        if (seconds < 0) {
          clearInterval(timer)
          btn.textContent = originalText
          // btn.disabled = false
          btn.removeAttribute('disabled')
        }
      }, 1000)

      // btn.disabled = true
      btn.setAttribute('disabled', '')
    },

    onSubmit () {
      // formData
      if (!this.formData.name) {
        this.$message({ message: '请输入姓名', type: 'warning' })
        return
      }
      if (!this.formData.company) {
        this.$message({ message: '请输入公司', type: 'warning' })
        return
      }
      if (!this.formData.email) {
        this.$message({ message: '请输入邮箱', type: 'warning' })
        return
      }
      if (!this.formData.phone) {
        this.$message({ message: '请输入手机号', type: 'warning' })
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.formData.phone)) {
        this.$message({ message: '请输入正确的手机号', type: 'warning' })
        return
      }
      if (!this.formData.verifyCode) {
        this.$message({ message: '请输入验证码', type: 'warning' })
        return
      }
      // '当前商品数量为0，请添加商品'
      if (this.total <= 0) {
        this.$message({ message: '当前商品数量为0，请添加商品', type: 'warning' })
        return
      }
      // 创建订单
      let url = 'https://www.msup.com.cn/api/api-common/create-order-and-order-goods'
      let params = `?goodsId=${this.ticket.goodsId}`
      params += `&amount=${this.ticket.amount}`
      params += `&number=${+this.total}`
      params += `&createUserId=${this.ticket.createdUser}`
      params += `&hash=${this.hash}`
      params += `&name=${this.formData.name}`
      params += `&email=${this.formData.email}`
      params += `&company=${this.formData.company}`
      params += `&phone=${this.formData.phone}`
      params += `&captcha=${this.formData.verifyCode}`
      if (this.formData.invoiceInfo) {
        params += `&invoice=${this.formData.invoiceInfo}`
      }
      this.createOrder(url, params)
    },
    createOrder (url, params) {
      this.$http.jsonp(url + params)
        .then((data) => {
          return data.json()
        })
        .then(response => {
          if ([200, '200'].includes(response.status)) {
            // this.$message({message: '订单创建成功', type: 'success'})
            let order = response.data.orderNumber
            // eslint-disable-next-line no-undef
            // $('#pay-link-tag').attr('href', `https://www.msup.com.cn/shopping/default/pay-stands?order=${order}&refer=https%3A%2F%2Fcase.msup.com.cn%2Fpay%2Fpay-success.html%3Forder%3D${order}`)
            // eslint-disable-next-line no-undef
            $('#pay-link-tag').attr('href', `https://www.msup.com.cn/shopping/default/pay-stands?order=${order}&refer=${encodeURIComponent(location.origin)}`)
            document.getElementById('pay-link-tag').click()
          } else {
            this.$message.closeAll()
            this.$message({message: response.message || '订单创建失败', type: 'warning'})
          }
        }).catch(error => {
          console.error('订单创建失败:', error)
          this.$message.closeAll()
          this.$message({message: '订单创建失败，请重试', type: 'warning'})
        })
    },
    backOrder () {
      this.global.hashParam['qd'] = ''
      // this.$router.replace(this.formatHref('/order', {qd: ''}))
      this.$router.replace(this.formatHref('/order', {back: 1}, this.global.area_id))
    },

    initInfo () {
      const token = localStorage.getItem('token')
      if (!token) return
      this.$http.jsonp('https://www.msup.com.cn/api/top-api/user-set', {
        params: {
          token
        }
      }).then((data) => {
        return data.json()
      }).then(response => {
        // console.log('initInfo', response)
        if ([200, '200'].includes(response.status)) {
          this.formData.name = response.data.name
          this.formData.company = response.data.company
          this.formData.email = response.data.email
          this.formData.phone = response.data.phone
        }
      })
    }
  }
}
</script>

<style lang="scss">
#page-order-code {
  .banner.ban_title {
    max-height: 180px;
    h1 {
      font-size: 28px !important;
      img {
        width: auto;
        height: 28px;
        margin: 0 5px;
      }
    }
  }

  .pc_content {
    padding: 0 15px;
    .con.wrap-flex {
      align-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
    }
  }

  .alltic {
    margin-top: 30px;
    margin-bottom: 30px;

    &.pc {
      table {
        width: 100%;
        border-collapse: collapse;

        tr {
          border-bottom: 1px solid var(--main-color);

          &.caption {
            font-weight: bold;
            background: var(--main-color);
            td {
              color: #fff;
              font-weight: 500;
            }
          }

          td {
            padding: 15px 10px;
            text-align: center;

            &.t1 { width: 25%; }
            &.t2 { width: 25%; }
            &.t3 { width: 30%; }
            &.t4 { width: 20%; }

            span {
              text-decoration: line-through;
              color: #999;
            }

            button{
              font-size: 16px;
              line-height: 28px;
              + span {
                text-decoration: none;
                color: #333;
              }
              &[disabled] + span {
                color: #999;
              }
            }
          }
        }
      }

      .a1, .a2 {
        width: 30px;
        height: 30px;
        border: 1px solid #ddd;
        background: #fff;
        cursor: pointer;

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }

      .tsspan {
        display: inline-block;
        width: 40px;
        text-align: center;
      }
    }

    &.mob {
      .single {
        background: #fff;
        border-radius: 8px;
        margin-bottom: 15px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);

        .top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px;
          border-bottom: 1px solid #eee;

          .le {
            display: flex;
            align-items: center;

            div {
              margin-right: 10px;

              img {
                width: 20px;
                height: 20px;
              }
            }

            p {
              font-size: 16px;
              font-weight: bold;
              margin: 0;
            }
          }

          .ri {
            display: flex;
            align-items: center;

            button {
              width: 30px;
              height: 30px;
              border: 1px solid #ddd;
              background: #fff;
              font-size: 16px;
              border-radius: 4px;

              &:disabled {
                opacity: 0.5;
              }
            }

            p {
              margin: 0 10px;
              min-width: 20px;
              text-align: center;
            }
          }
        }

        .min {
          padding: 15px;

          .pri {
            display: flex;
            align-items: baseline;
            margin-bottom: 5px;

            p {
              font-size: 14px;
              color: #ff4d4f;
            }

            h1 {
              font-size: 20px;
              color: #ff4d4f;
              margin: 0 5px;
            }

            span {
              font-size: 12px;
              color: #999;
            }
          }

          h2 {
            font-size: 14px;
            color: #999;
            text-decoration: line-through;
            margin-bottom: 5px;
          }

          h3 {
            font-size: 14px;
            color: #666;
            margin: 0;
          }
        }
      }
    }
  }

  .form-container {
    width: 40%;
    max-width: 400px;
    padding: 20px;

    .form-group {
      margin-bottom: 15px;
      display: flex;
      align-items: flex-start;
      align-content: flex-start;
      justify-content: flex-start;
      flex-wrap: nowrap;

      label {
        min-width: 80px;
        display: block;
        font-size: 16px;
        line-height: 38px;
        margin: 0;
        white-space: nowrap;
        .required {
          width: 10px;
          text-align: left;
          display: inline-block;
          margin-left: -12px;
          margin-right: 2px;
          color: red;
        }
      }

      input, textarea {
        width: 100%;
        padding: 8px 12px;
        font-size: 16px;
        line-height: 18px;
        border: 1px solid #ddd;
        border-radius: 4px;
      }

      .verify-code-container {
        display: flex;
        width: 100%;

        input {
          flex: 1;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        // .get-code-btn {
        button {
          padding: 8px 12px;
          background: var(--main-color);
          color: white;
          border: none;
          border-radius: 0 4px 4px 0;
          cursor: pointer;
          white-space: nowrap;

          &:hover {
            background: #40a9ff;
          }

          &:disabled {
            opacity: .6;
            cursor: not-allowed !important;
          }
        }
      }
    }
  }

  .method-container {
    width: 60%;
    max-width: 800px;
    padding: 20px;
    text-align: right;
    display: grid !important;
    flex-wrap: nowrap;
    h1 {
      align-content: flex-end;
      align-items: flex-end;
      font-size: 40px;
      span {
        font-size: 20px;
        padding-bottom: 5px;
      }
    }
    .morebtn {
      // width: fit-content;
      width: 100%;
      margin-top: 15px;
      text-align: right;
    }
    p {
      max-width: 280px;
      margin-top: 30px;
      text-align: left;
      color: #666;
      text-align: justify;
      span {
        display: inline-block;
        color: red;
      }
    }
  }

  @media (max-width: 767px) {
    .form-container {
      width: 100%;
      max-width: 100%;
      padding: 15px;
      padding-right: 0;

      .form-group {
        label {
          min-width: 70px;
        }
        input, textarea {
          padding-left: 8px;
          padding-right: 4px;
        }
        label, input, textarea {
          font-size: 15px;
        }
      }
    }

    .method-container {
      width: 100%;
      padding-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/Code.vue